import axios from 'axios';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

import styles from './CreateFavListForm.module.css';
import Button from '../../../../UI/Buttons/Button/Button';
import FormField from '../../../../UI/FormUI/FormField/FormField';
import { PlusIcon } from '../../../../../assets/images/icons';
import { getFavoriteTalents } from '../../../../../services/TalentsService';

function CreateFavListForm({ onSubmit, favTalents, page, per_page, filters, setFavTalents, onclose, talentId, ...props }) {
    const { t } = useTranslation();
    const user = useSelector(state => state.user.user);

    const [jobOptions, setJobOptions] = useState([
        { id: 1, label: 'test', value: 'job1' },
        { id: 2, label: 'test 2', value: 'job2' },
        { id: 3, label: 'test 3', value: 'job3' },
    ]);
    useEffect(() => {
        const isFav = favTalents.filter((e) => e.id == talentId)
        if (isFav?.length > 0) {
            const preselectedJobs = jobOptions
                .filter(job => isFav.some(fav => fav.list_id === job.id))
                .map(job => job.value);
            formik.setFieldValue('selectedJobs', preselectedJobs);
        }
    }, [favTalents, jobOptions])

    useEffect(() => {
        const fetchFavoriteLists = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}talents/favorites/lists?userId=${user.id}`
                );
                const fetchedLists = response.data.favoriteLists.map((item) => ({
                    id: item.id,
                    label: item.list_name,
                    value: item.list_name,
                }));

                setJobOptions(fetchedLists);
            } catch (error) {
                console.error("Error fetching favorite lists:", error);
            }
        };

        fetchFavoriteLists()
    }, [user.id]);
    const handleFav = async (values) => {
        try {
            const selectedListIds = values.selectedJobs.map((jobValue) => {
                const matchedJob = jobOptions.find((job) => job.value === jobValue);
                return matchedJob?.id;
            }).filter(Boolean);
            await axios.post(`${process.env.REACT_APP_API_URL}talents/favorites/add`, {
                userId: user.id,
                talentId: talentId,
                listIds: selectedListIds,
            });
        } catch (error) {
        }
        const responseTalent = await getFavoriteTalents(user.id, page, per_page, filters)
        setFavTalents(responseTalent.talents)

        onclose()
    }
    const formik = useFormik({
        initialValues: {
            listName: '',
            selectedJobs: [],
        },
        onSubmit: async (values) => {
            handleFav(values)
                .then(async (response) => {
                    toast.success(values.selectedJobs.length > 0 ?
                        t('job.user_added_to_favorites') :
                        t('job.user_removed_from_favorites'))
                    const responseTalent = await getFavoriteTalents(user.id, page, per_page, filters)
                    setFavTalents(responseTalent.talents)
                })
                .catch((error) => {
                    if (error?.response?.data?.error) {
                        toast.error(error.response.data.error);
                    }
                });
        },
    });

    const handleCheckboxChange = (jobValue) => {
        const { selectedJobs } = formik.values;
        if (selectedJobs.includes(jobValue)) {
            formik.setFieldValue(
                'selectedJobs',
                selectedJobs.filter(item => item !== jobValue)
            );
        } else {
            formik.setFieldValue('selectedJobs', [...selectedJobs, jobValue]);
        }
    };

    const addJobToList = () => {
        if (formik.values.listName.trim() !== '') {
            const newJobOption = {
                id: jobOptions.length + 1, // Generate unique ID
                label: formik.values.listName,
                value: `job${jobOptions.length + 1}`,
            };
            const response = axios.post(`${process.env.REACT_APP_API_URL}talents/favorites/list`, {
                userId: user.id, // Replace with actual userId
                listName: formik.values.listName,
            });
            setJobOptions([...jobOptions, newJobOption]); // Add new job to list
            formik.setFieldValue('listName', '');
        }
    };

    return (
        <form onSubmit={formik.handleSubmit} {...props}>
            <div>
                <div className={styles.contentBody}>
                    <div style={{ width: "100%" }}>
                        <FormField
                            name="listName"
                            type="text"
                            placeholder={t('forms.CreateFavList.listName')}
                            hasBorder
                            onChange={formik.handleChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    addJobToList();
                                }
                            }}
                            style={{ width: "100%" }}
                            value={formik.values.listName}
                            error={formik.touched.listName && formik.errors.listName}
                        />
                    </div>
                    <img
                        src={PlusIcon}
                        onClick={addJobToList}
                        style={{ marginBottom: 20, cursor: "pointer" }}
                    />
                </div>
                <div className={`${styles.checkboxWrapper} ${styles.listContainer}`}>
                    {jobOptions.map((job) => (
                        <div key={job.id} className={styles.checkboxItem} onClick={() => handleCheckboxChange(job.value)}>
                            <input
                                type="checkbox"
                                id={`job-${job.id}`}
                                value={job.value}
                                checked={formik.values.selectedJobs.includes(job.value)}
                                onChange={() => handleCheckboxChange(job.value)}
                                className={styles.checkbox}
                            />
                            <div className={styles.checkboxLabel}>
                                {job.label}
                            </div>
                        </div>
                    ))}
                </div>
                {formik.touched.selectedJobs && formik.errors.selectedJobs && (
                    <div className={styles.error}>{formik.errors.selectedJobs}</div>
                )}
            </div>

            <div>
                <Button type="submit" className={styles.button}>
                    {t('forms.workExperience.add')}
                </Button>
            </div>
        </form>
    );
}

export default CreateFavListForm;
